import React, { Component } from "react";
import {
	TabContent,
	TabPane,
	ListGroup,
	ListGroupItem,
	Row,
	Col,
	Button
} from "reactstrap";
import PropTypes from "prop-types";
import Fire from "../../components/firebase/Fire";
import { Link } from "react-router-dom";
import {companyInformationStatus$} from "../../views/company-information/company-information";

const propTypes = {
	children: PropTypes.node
};

const defaultProps = {};

class DefaultAside extends Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.state = {
			activeTab: "1"
		};
		this.logout = this.logout.bind(this);
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	logout() {

		Fire.auth().signOut().then(() => {
			companyInformationStatus$.next(true);
		});
		/**heap.io **reset identity** */
		window.heap.resetIdentity();
	}

	render() {
		// eslint-disable-next-line
		const { children, ...attributes } = this.props;

		return (
			<React.Fragment>
				<TabContent style={{ height: "100%" }} activeTab={this.state.activeTab}>
					<TabPane tabId="1">
						<ListGroup
							style={{ marginTop: "2rem" }}
							className="list-group-accent"
						>
						{/*	<Link
								to="/settings/profile"
								style={{ textDecoration: "none", color: "black" }}
							>
								<Button
									outline
									color={"primary"}
									style={{
										width: "100%",
										border: "none",
										textAlign: "left",
										borderRadius: "0px",
										padding: "10px 21px"
									}}
								>
									<i style={{ fontSize: "20px" }} className="icon icon-user" />
									<span style={{ marginLeft: "15px", fontSize: "15px" }}>
										Profile
									</span>
								</Button>
								</Link> */}
						{/*	<a
								href="https://bitbucket.org/talentscript/ts_admin_dashboard_test/issues/new"
								style={{ textDecoration: "none" }}
							>
								<Button
									outline
									color={"primary"}
									style={{
										width: "100%",
										border: "none",
										textAlign: "left",
										borderRadius: "0px",
										padding: "10px 21px"
									}}
								>
									<i
										style={{ fontSize: "20px" }}
										className="icon-question icons"
									/>
									<span style={{ marginLeft: "15px", fontSize: "15px" }}>
										Help
									</span>
								</Button>
								</a> */}

							<a
								href="https://talentscript.com"
								style={{ textDecoration: "none" }}
							>
								<Button
									outline
									color={"primary"}
									style={{
										width: "100%",
										border: "none",
										textAlign: "left",
										borderRadius: "0px",
										padding: "10px 21px"
									}}
								>
									<i style={{ fontSize: "20px" }} className="icon-info icons" />
									<span style={{ marginLeft: "15px", fontSize: "15px" }}>
										About Us
									</span>
								</Button>
							</a>

							<a
								href="mailto:info@talentscript.com?subject=Regarding%20TalentScript"
								style={{ textDecoration: "none" }}
							>
								<Button
									outline
									color={"primary"}
									style={{
										width: "100%",
										border: "none",
										textAlign: "left",
										borderRadius: "0px",
										padding: "10px 21px"
									}}
								>
									<i
										style={{ fontSize: "20px" }}
										className="icon-envelope-letter icon"
									/>
									<span style={{ marginLeft: "15px", fontSize: "15px" }}>
										Contact Us
									</span>
								</Button>
							</a>
						</ListGroup>
						<ListGroup className="list-group-accent">
							<Button
								outline
								onClick={this.logout}
								color={"danger"}
								style={{
									width: "100%",
									border: "none",
									textAlign: "left",
									borderRadius: "0px",
									padding: "10px 21px"
								}}
							>
								<i style={{ fontSize: "20px" }} className="icon-logout icons" />
								<p style={{ margin: "0px 15px", fontSize: "15px", display: "inline-block"}}
								>
									Logout
								</p>
							</Button>
							{/* <Row>
									<Col
										sm={"2"}
										style={{ color: "#ffffff", fontSize: "18px" }}
										className="icon-logout icons d-block"
									/>
									<Col sm={"8"} >
										<h5
											style={{
												fontFamily: "sans-serif",
												color: "#ffffff",
												fontSize: "17px",
												zIndex: 3
											}}
										>
											Logout
										</h5>
									</Col>
								</Row> */}
						</ListGroup>
					</TabPane>
				</TabContent>
			</React.Fragment>
		);
	}
}

DefaultAside.propTypes = propTypes;
DefaultAside.defaultProps = defaultProps;

export default DefaultAside;
